import React, { FunctionComponent } from 'react';
import { Helmet } from 'react-helmet';

import { Layout } from '../components';
import { Contact } from '../components/contact/';
import { canonicalUrl } from '../utils/canonicalUrl';

const ContactPage: FunctionComponent = () => (
  <>
    <Helmet>
      <title>Treet</title>
      <link rel="canonical" href={canonicalUrl('/meista')} />
    </Helmet>
    <Layout>
      <Contact />
    </Layout>
  </>
);

ContactPage.displayName = 'ContactPage';

export default ContactPage;
